import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const FranchisesAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.franchisePage,
      component: React.lazy(() => import('./pages/FranchiseDetailsPage')),
      auth: authRoles.fullAccess,
    },
  ],
};

export default FranchisesAppConfig;
